import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface DashboardRefreshContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
  isRefreshing: boolean;
  setIsRefreshing: (loading: boolean) => void;
}

const DashboardRefreshContext = createContext<DashboardRefreshContextType | undefined>(undefined);

interface DashboardRefreshProviderProps {
  children: ReactNode;
}

export function DashboardRefreshProvider({ children }: DashboardRefreshProviderProps) {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
    setIsRefreshing(true);
  }, []);

  return (
    <DashboardRefreshContext.Provider 
      value={{ 
        refreshTrigger, 
        triggerRefresh, 
        isRefreshing, 
        setIsRefreshing 
      }}
    >
      {children}
    </DashboardRefreshContext.Provider>
  );
}

export function useDashboardRefresh() {
  const context = useContext(DashboardRefreshContext);
  if (context === undefined) {
    throw new Error('useDashboardRefresh must be used within a DashboardRefreshProvider');
  }
  return context;
}